module.exports = __webpack_public_path__ + "img/coupon.864d87f8.png";